import React from 'react';

import { DownOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import Dropdown from '..';
import { DataType, StaticContext } from 'app/providers/StaticProvider';
import styled from '@emotion/styled';

const StyledLabel = styled.a`
  color: #3a4861;
`;
const DropdownInspector = (props: {
  value?: Array<string | number> | string | number | null | undefined;
  onApply?: (
    values: Array<string | number> | string | number | null | undefined
  ) => void;
  onReset?: () => void;
  renderLabel?: (props: any) => React.ReactElement;
}) => {
  const { value } = props;
  const { getOptions } = React.useContext(StaticContext);

  const [selectedValue, setSelectedValue] = React.useState<
    Array<string | number>
  >(['all']);

  const onApply = (values: Array<string | number>) => {
    setSelectedValue(values);
    if (props.onApply) {
      props.onApply(values);
    }
  };

  const onReset = () => {
    if (props.onReset) {
      props.onReset();
    }
  };

  React.useEffect(() => {
    setSelectedValue(value as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Dropdown.FilterDropdown
      renderLabel={
        props.renderLabel
          ? props.renderLabel
          : () => {
              return (
                <StyledLabel type="link">
                  <Space size={8}>
                    {selectedValue?.includes('all')
                      ? 'All Inspectors'
                      : `All Inspectors(${selectedValue?.length ?? ''})`}
                    <DownOutlined />
                  </Space>
                </StyledLabel>
              );
            }
      }
      value={selectedValue}
      onApply={onApply}
      onReset={onReset}
      options={[{ value: 'all', label: ' All Inspectors' }].concat(
        getOptions(DataType.INSPECTORS)
      )}
    ></Dropdown.FilterDropdown>
  );
};

export default DropdownInspector;
